import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: '',
  email: '',
  message: '',
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_q6u87vt", "template_r8lsey2", e.target, "qwJdBQibS11pHmmNH")
      .then(
        (result) => {
          console.log(result.text);

          alert("Wiadomość została wysłana");
          clearState();
        },
        (error) => {
          alert("Nie udało się wysłać wiadomości, spróbuj ponownie później.");
          console.log(error.text);
        }
      );
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Napisz do nas</h2>
                <p>
           Opisz czego potrzebujesz, a my skontaktujemy się najszybciej jak to będzie możliwe.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Imię"
                        required
                        onChange={handleChange}
                        value={name}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                        value={email}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="6"
                    placeholder="Wiadomość"
                    required
                    onChange={handleChange}
                    value={message}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
    Wyślij wiadomość
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Informacje kontaktowe</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i>Adres
                </span>
                {props.data ? props.data.address : "jeszcze chwilę..."}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i>Telefon
                </span>{" "}
                {props.data ? props.data.phone : "jeszcze chwilę..."}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i>Email
                </span>{" "}
                {props.data ? props.data.email : "jeszcze chwilę..."}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"} target={"_blank"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  {/*<li>*/}
                  {/*  <a href={props.data ? props.data.instagram : "/"} target={"_blank"}>*/}
                  {/*    <i className="fa fa-instagram"></i>*/}
                  {/*  </a>*/}
                  {/*</li>*/}
                  {/*<li>*/}
                  {/*  <a href={props.data ? props.data.youtube : "/"} target={"_blank"}>*/}
                  {/*    <i className="fa fa-youtube"></i>*/}
                  {/*  </a>*/}
                  {/*</li>*/}
                  {/*<li>*/}
                  {/*  <a href={props.data ? props.data.google : "/"} target={"_blank"}>*/}
                  {/*    <i className="fa fa-google"></i>*/}
                  {/*  </a>*/}
                  {/*</li>*/}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2024 ElektrykaPlus.pl | Wszelkie prawa zastrzeżone
          </p>
        </div>
      </div>
    </div>
  );
};
